var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1085 1.33594H1.89179C1.58345 1.33594 1.3335 1.58589 1.3335 1.89423C1.3335 3.67106 2.03934 5.37511 3.29574 6.63152L4.10853 7.44431C4.18925 7.52502 4.22961 7.56538 4.2585 7.60414C4.43475 7.84055 4.43475 8.16466 4.2585 8.40107C4.22961 8.43983 4.18925 8.48018 4.10854 8.5609L3.29574 9.37369C2.03934 10.6301 1.3335 12.3341 1.3335 14.111C1.3335 14.4193 1.58345 14.6693 1.89179 14.6693H10.1085C10.4169 14.6693 10.6668 14.4193 10.6668 14.111C10.6668 12.3341 9.96099 10.6301 8.70458 9.37369L7.89179 8.5609C7.81108 8.48018 7.77072 8.43983 7.74183 8.40107C7.56558 8.16466 7.56558 7.84055 7.74183 7.60414C7.77072 7.56538 7.81108 7.52502 7.89179 7.44431L8.70458 6.63152C9.96099 5.37511 10.6668 3.67106 10.6668 1.89423C10.6668 1.58589 10.4169 1.33594 10.1085 1.33594Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.07bbf911eccb25be90a735e5f28761ff.svg";
export { ForwardRef as ReactComponent };